export const address= 'https://backend.jainajewellers.in'
export const address1= 'http://192.168.0.101:8080' 